const platforms = [
  {
    name: "Twitch",
    handle: "@oldmanmurks",
    followers: "10.4K",
    desc: "Catch live tactical gameplay every Tuesday, Thursday & Sunday. Full matches, analysis breakdowns, and viewer games.",
    icon: "ri-twitch-fill",
    color: "bg-[#9146FF]/10 border-[#9146FF]/30 hover:border-[#9146FF]/70",
    iconColor: "text-[#9146FF]",
    badge: "LIVE",
    badgeColor: "bg-[#9146FF]",
    link: "https://www.twitch.tv/oldmanmurks",
    stat: "Avg 340 viewers",
  },
  {
    name: "YouTube",
    handle: "@OldManMurksGaming",
    followers: "24.6K",
    desc: "Weekly highlight reels, tutorials, gear reviews and full match VODs. Subscribe for tactical breakdowns of the highest level plays.",
    icon: "ri-youtube-fill",
    color: "bg-red-900/10 border-red-900/30 hover:border-red-600/70",
    iconColor: "text-red-500",
    badge: "1M+ VIEWS",
    badgeColor: "bg-red-700",
    link: "#",
    stat: "Weekly uploads",
  },
  {
    name: "Twitter / X",
    handle: "@OldManMurks",
    followers: "8.2K",
    desc: "Daily gaming takes, clip drops, community polls, tournament news, and unfiltered commentary on the gaming world.",
    icon: "ri-twitter-x-fill",
    color: "bg-gray-800/30 border-gray-700/30 hover:border-gray-400/60",
    iconColor: "text-gray-200",
    badge: "DAILY",
    badgeColor: "bg-gray-700",
    link: "#",
    stat: "5x/week posts",
  },
  {
    name: "Instagram",
    handle: "@OldManMurksGaming",
    followers: "6.8K",
    desc: "Behind the scenes, gaming setup posts, tournament updates, fan art showcases and personal moments from the grind.",
    icon: "ri-instagram-fill",
    color: "bg-pink-900/10 border-pink-900/30 hover:border-pink-600/60",
    iconColor: "text-pink-400",
    badge: "REELS",
    badgeColor: "bg-pink-700",
    link: "#",
    stat: "3x/week posts",
  },
  {
    name: "TikTok",
    handle: "@oldmanmurks",
    followers: "32.1K",
    desc: "Short-form content, crazy clips, funny moments, and quick tips. The place where Old Man Murks goes viral.",
    icon: "ri-tiktok-fill",
    color: "bg-cyan-900/10 border-cyan-900/30 hover:border-cyan-500/60",
    iconColor: "text-cyan-400",
    badge: "VIRAL",
    badgeColor: "bg-cyan-700",
    link: "https://www.tiktok.com/@oldmanmurks",
    stat: "100K+ likes",
  },
  {
    name: "Discord",
    handle: "Murks Battalion",
    followers: "2,140",
    desc: "Join the community! Team coordination, strategy discussions, event announcements, gaming partner lookups, and exclusive giveaways.",
    icon: "ri-discord-fill",
    color: "bg-indigo-900/10 border-indigo-900/30 hover:border-indigo-500/60",
    iconColor: "text-indigo-400",
    badge: "JOIN",
    badgeColor: "bg-indigo-700",
    link: "#",
    stat: "Active daily",
  },
];

export default function SocialMedia() {
  return (
    <section
      id="social"
      className="relative py-28 overflow-hidden"
      style={{
        backgroundImage: `url("https://public.readdy.ai/ai/img_res/835d1e9e7f0cf2b69e9e0811641b92f2.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-urban-dark/92" />

      <div className="relative z-10 max-w-7xl mx-auto px-8 md:px-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div className="flex items-center gap-4">
            <div className="w-1 h-12 bg-red-600" />
            <div>
              <p className="font-rajdhani text-red-500 uppercase tracking-widest text-sm font-semibold">Follow The Journey</p>
              <h2 className="font-bebas text-5xl md:text-6xl text-white tracking-wider">Social Media</h2>
            </div>
          </div>
          <p className="font-rajdhani text-gray-400 text-base max-w-md leading-relaxed">
            Join <strong className="text-white">75K+</strong> followers across platforms. Never miss a highlight, stream, or drop from the Old Man.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {platforms.map((p) => (
            <a
              key={p.name}
              href={p.link}
              className={`block bg-urban-card border rounded-sm p-6 transition-all duration-300 cursor-pointer group ${p.color} hover:-translate-y-1`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className={`w-12 h-12 flex items-center justify-center rounded-sm bg-urban-surface text-2xl ${p.iconColor}`}>
                    <i className={p.icon} />
                  </div>
                  <div>
                    <p className="font-rajdhani font-bold text-white text-base">{p.name}</p>
                    <p className="font-rajdhani text-gray-500 text-xs">{p.handle}</p>
                  </div>
                </div>
                <span className={`${p.badgeColor} text-white font-rajdhani font-bold text-xs px-2.5 py-1 rounded-sm uppercase tracking-wider`}>
                  {p.badge}
                </span>
              </div>

              <div className="mb-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-bebas text-3xl text-white">{p.followers}</span>
                  <span className="font-rajdhani text-gray-500 text-xs uppercase tracking-widest">Followers</span>
                </div>
                <span className="font-rajdhani text-gray-500 text-xs">{p.stat}</span>
              </div>

              <p className="font-rajdhani text-gray-400 text-sm leading-relaxed mb-4">{p.desc}</p>

              <div className={`flex items-center gap-2 ${p.iconColor} font-rajdhani font-bold text-sm uppercase tracking-wider group-hover:gap-3 transition-all`}>
                <span>Follow Now</span>
                <i className="ri-arrow-right-line" />
              </div>
            </a>
          ))}
        </div>

        <div className="mt-16 bg-urban-card border border-urban-border rounded-sm p-8 flex flex-col md:flex-row items-center gap-8">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 flex items-center justify-center bg-red-900/30 border border-red-900/50 rounded-sm">
              <img
                src="https://public.readdy.ai/ai/img_res/eae5b4cf-72f5-4242-8c48-d94be5569ffc.png"
                alt="Old Man Murks"
                className="w-12 h-12 rounded-full object-cover"
              />
            </div>
            <div>
              <p className="font-bebas text-2xl text-white tracking-wider">Join The Murks Battalion</p>
              <p className="font-rajdhani text-gray-400 text-sm">The community that never quits</p>
            </div>
          </div>
          <div className="flex-1 flex flex-col md:flex-row items-center gap-4 md:justify-end">
            <div className="grid grid-cols-3 gap-6">
              {[{ label: "Total Followers", value: "75K+" }, { label: "Platforms", value: "6" }, { label: "Content Pieces", value: "500+" }].map((s) => (
                <div key={s.label} className="text-center">
                  <p className="font-bebas text-2xl text-red-500">{s.value}</p>
                  <p className="font-rajdhani text-gray-500 text-xs uppercase tracking-wider">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
